import type { ReactNode } from 'react';
import { Inbox } from 'lucide-react';
import { FadeIn } from '@/components/motion/Motion';

/**
 * Estado vazio para tabelas/listas sem dados. Comunica "nada encontrado" —
 * o título default cobre o caso genérico; passe `description` para detalhar.
 */
export function EmptyState({
  title = 'Sem dados para exibir',
  description,
  icon,
  className,
  dataQa,
}: {
  title?: string;
  description?: string;
  icon?: ReactNode;
  className?: string;
  dataQa?: string;
}) {
  return (
    <FadeIn className={className}>
      <div
        data-qa={dataQa}
        className="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center"
      >
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-agnes-bg-muted text-agnes-text-muted">
          {icon ?? <Inbox className="h-7 w-7" />}
        </div>
        <div>
          <p className="font-medium text-agnes-text-primary">{title}</p>
          {description && (
            <p className="mx-auto mt-1 max-w-md text-sm text-agnes-text-muted">{description}</p>
          )}
        </div>
      </div>
    </FadeIn>
  );
}
